import { colors, breakpoints } from '@web-for-marketing/react-ui';

export const blogCategoryNavStyle = {
    navContainer: {
        display: 'flex',
        justifyContent: 'start',
        height: '4.5rem',
    },
    categoryContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        borderBottom: `1px solid ${colors.core.haze}`,
        flexWrap: 'nowrap',
        whiteSpace: 'nowrap',
        overflowX: 'auto',
        '&::-webkit-scrollbar': {
            display: 'none',
        },

        [`@media (max-width: ${breakpoints.md})`]: {
            flexWrap: 'nowrap',
            whiteSpace: 'nowrap',
            overflowX: 'auto',
            '&::-webkit-scrollbar': {
                display: 'none',
            },
        },
    },
    navItem: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        margin: '0 1.2rem',
        height: '100%',
    },
    navLink: {
        textDecoration: 'none !important',
        outline: 'none',
        borderRadius: '0.4rem',
        padding: '0.4rem',
        transition: 'color 300ms ease',
        '&:hover, &:focus': {
            color: colors.text.activePrimary,
        },
        '&:focus': {
            boxShadow: `0 0 0 0.1rem ${colors.text.activePrimary}`,
        },
        '&::after': {
            transition: 'border-color 300ms ease',
            content: '""',
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            borderBottom: `2px solid ${colors.transparent}`,
            '&:hover': {
                borderColor: colors.text.activePrimary,
            },
        },
        '&:hover::after': {
            borderColor: colors.text.activePrimary,
        },
    },
    separator: {
        height: '2.4rem',
        borderRight: `2px solid ${colors.core.smoke}`,
        [`@media (max-width: ${breakpoints.md})`]: {
            display: 'none',
        },
    },
    arrowContainer: {
        margin: '0 0 0 1rem',
        [`@media (max-width: ${breakpoints.sm})`]: {
            display: 'none',
        },
    },
    arrowButton: {
        '&:hover': {
            backgroundColor: `${colors.core.cloud} !important`,
            color: colors.text.activeSecondary,
        },
    },
    flipArrow: {
        transform: 'scaleX(-1)',
    },
    arrowIcon: {
        color: colors.text.activeSecondary,
    },
    hiddenAnchor: {
        width: '100%',
        height: 1,
        marginBottom: -1,
        visibility: 'hidden',
    },
} as const;
